<template>
    <i v-if="loading" class="fa fa-spinner fa-pulse loading" style="font-size: 10px;"></i>
    <span v-if="totalNotifications && !loading" class="badge badge-notification">{{ totalNotifications }}</span>
</template>

<script setup>
import axios from 'axios';
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue"
const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);

const totalNotifications = ref(null)
const loading = ref(false)
onMounted(() => {
    if (contractData.value.contrato_id) {
        getTotalNotifications();
    }
});
const getTotalNotifications = async () => {
    try {
        loading.value = true;
        const response = await axios.get(`/notification/${contractData.value.contrato_id}/count`);
        totalNotifications.value = formatTotalNotifications(response.data.count)
    } catch (error) {
        console.log(error);
    } finally {
        // showToast('Dados Atualizado.', 'success');
        loading.value = false;
    }
};

const formatTotalNotifications = (total) => {
    if (total > 10) {
        return '9+'
    }
    return total;
};


const watcherFunction = () => {
    return (newValue, oldValue) => {
        if (newValue && oldValue && typeof newValue === 'object' && typeof oldValue === 'object' && newValue.contrato_unidade !== oldValue.contrato_unidade) {
            getTotalNotifications();
        }
    };
};
watch(contractData, watcherFunction());
</script>

<style>
.badge-notification {
    position: absolute;
    font-weight: 400 !important;
    top: -8px;
    right: -10px;
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 0.05em 0.35em !important;
}

.loading {
    position: absolute;
    top: -8px;
    right: -10px;
    color: white;
    border-radius: 50%;
    padding: 0.05em 0.35em !important;
}
</style>